<template>
  <div>
    <div class="m-background m-background--media-1"></div>
    <img class="leap" src="../assets/images/logos/leap-skills-black-new.png" />
    <div class="l-container l-pad">
      <img
        class="l--right"
        src="../assets/images/students/students__all-2.png"
      />
      <img src="../assets/images/logos/ucas_logo.svg"  class="ucas-logo hidden" />
      <img src="../assets/images/logos/logo__unite.png" class="unite-logo hidden" />
      <div class="intro">
        <p>Here's your chance to have a sneak peek into the world of a group of university students, who live together.</p>
        <p>As you explore their flat you'll encounter eight different situations with potential solutions.</p>
        <p>Think about how you'd react to discover which student has the closest personality to yours.</p>
        <p>Let's start the tour and meet the flatmates.</p>
      </div>
      <router-link
        class="m-btn m-btn--left m-btn__primary"
        :to="{ name: 'intro', params: { id: 'advik' } }"
        >Meet the students &nbsp;<span
          class="m-btn__arrow"
          style="display:inline-block; margin-top: -0.4em;"
        ></span>
      </router-link>
    </div>
    <MainFooter />
  </div>
</template>

<script>
// import { mapActions } from 'vuex'
import MainFooter from '../components/MainFooter'
export default {
  created () {
    // this.storeResponsesInFirebase()
  },
  methods: {
    // ...mapActions(['storeResponsesInFirebase'])
  },
  components: {
    MainFooter
  },
  name: 'Start'
}
</script>

<style scoped lang="scss">
/*a {
  position: absolute;
  bottom: 30px;
  right: 30px;
  display: inline-flex;
  padding: 0px;
  align-items: center;
  padding: 0px 1em;
}*/

.hidden {
  display: none;
}
img.l--right {
  width: 66%;
  right: -40px;
  bottom: -1px;
}

img.leap {
  width: 150px;
  height: auto;
  position: absolute;
  top: 10px;
  right: 20px;
  width: 125px;
}
.unite-logo {
  width: 150px;
}
.ucas-logo  {
  width:150px;
  float:left;
  margin-right: 60px;
}

.intro {
  margin-top: 60px;
}

.enlarge-button {
  font-size: 200%;
}

@media (max-width: 899px) {
  img.l--right {
    width: 45%;
    right: 70px;
    bottom: -1px;
  }

  img.leap {
    width: 70px;
    height: auto;
    position: absolute;
    top: 10px;
    right: 20px;
  }
  .unite-logo {
    width: 125px;
  }
  .l__splash {
    width: 60%;
    font-size: 2.8rem;
  }
  .intro {
    width: 45%;
    padding: 10px 0;
  }
  .enlarge-button {
    font-size: 140%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Start.vue